import { intervalToDuration, formatDuration } from 'date-fns';

const intervals = /\s(second|minute|hour|day|week|year)s?/g;
export default (seconds, abbreviate = true) => {
  const durations = intervalToDuration({ start: 0, end: seconds * 1000 });
  const value = formatDuration(durations);
  if (!abbreviate) {
    return value;
  }
  return value.replace(intervals, (match, p1, p2) => {
    return p1[0];
  });
  // return value;
};
